import DistributorLayout from '@/layouts/DistributorLayout.vue'
import PublicLayout from '@/layouts/PublicLayout.vue'

export default [
  {
    path: '/recycling',
    name: 'recyclingReport',
    component: () => import('@/views/restricted/recycling/RecyclingReportView.vue'),
    meta: {
      requiresAuth: true,
      layout: DistributorLayout,
      permissions: ['DISTRIBUTOR_RECYCLING_READ']
    }
  },
  {
    path: '/recycling-files/create',
    name: 'recyclingCreate',
    component: () => import('@/views/restricted/recycling/create/RecyclingCreateView.vue'),
    props: (route) => ({
      recyclingFolderBoomerangId:
        typeof route.query.recyclingFolderBoomerangId === 'string'
          ? route.query.recyclingFolderBoomerangId
          : undefined
    }),
    meta: {
      requiresAuth: true,
      layout: DistributorLayout,
      hideHeader: true,
      permissions: ['DISTRIBUTOR_RECYCLING_CREATE']
    }
  },
  {
    path: '/public/recycling-folder/add-attachment',
    name: 'recyclingAddAttachment',
    component: () =>
      import('@/views/public-access/recycling-module/RecyclingAddAttachmentView.vue'),
    meta: {
      requiresAuth: false,
      publicCapability: true,
      layout: PublicLayout
    }
  }
]
